import { ResponseDTO } from './response-dto';

export interface ResendUserContextRoleRequestResponseDTO extends ResponseDTO {
    requestKey?: string;
    userEmail?: string;
}

export interface SaveEmailValidationResponseDTO extends ResponseDTO {
    responseEn?: string;
    responseEs?: string;
    responsePt?: string;
    responseFr?: string;
    referenceNum?: string;
    userEmail?: string;
    languageCd?: string;
}
